import { Component, OnInit } from '@angular/core';
import { RequestService } from 'src/app/core/services/request.service';
import { Observable } from 'rxjs';
import { Nomenclature } from 'src/app/shared/models/nomenclature';
import {
  FormControl,
  ControlContainer,
  FormGroupDirective,
  FormGroup
} from '@angular/forms';
import { FormErrorsService } from 'src/app/core/services/form-errors.service';
import { FormGroupService } from 'src/app/core/services/form-group.service';

@Component({
  selector: 'app-others',
  templateUrl: './others.component.html',
  styleUrls: ['./others.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class OthersComponent implements OnInit {
  parentFormGroup: FormGroup;
  howDoYouKnowAboutUsNomenclature$: Observable<Nomenclature[]>;

  constructor(
    private requestService: RequestService,
    private formErrorsService: FormErrorsService,
    private formGroupDirective: FormGroupDirective
  ) {}

  ngOnInit() {
    this.parentFormGroup = this.formGroupDirective.form;
    this.howDoYouKnowAboutUsNomenclature$ = this.requestService.getHowDoYouKnowAboutUsNomenclature();
  }

  public getError(fc: FormControl) {
    return this.formErrorsService.getErrorMessages(fc);
  }
}
